import { render, staticRenderFns } from "./HonorVideoDia.vue?vue&type=template&id=154174cd&scoped=true&"
import script from "./HonorVideoDia.vue?vue&type=script&lang=js&"
export * from "./HonorVideoDia.vue?vue&type=script&lang=js&"
import style0 from "./HonorVideoDia.vue?vue&type=style&index=0&id=154174cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154174cd",
  null
  
)

export default component.exports